import React, { useState } from 'react';
import './ChallengeNotification.css';
import { Trophy, XCircle, Coins } from 'lucide-react';

function ChallengeNotification({ notification, currentMoney, onDismiss, deductWager, coinsCollected = 0 }) {
    const [isExiting, setIsExiting] = useState(false);

    if (!notification) return null;

    const { type, opponentName, wager, rewardAmount, score } = notification;
    const isWin = type === 'win';

    // --- LOGIC UPDATE: Calculate Balance Display ---
    // 1. Standard Notification (Sender checking later): 
    //    - Win: money + reward. 
    //    - Loss: money (wager was already deducted when sent).
    // 2. Immediate Result (Player 2 just finished): 
    //    - Win: money + reward + coins. (Reward = Wager profit)
    //    - Loss: money - wager + coins. (Wager deducted now)
    
    const moneyChange = isWin ? rewardAmount : wager;
    
    let newBalance;
    if (deductWager) {
        // Immediate Result Mode (Player 2 Just Played)
        if (isWin) {
            newBalance = currentMoney + rewardAmount + coinsCollected;
        } else {
            newBalance = currentMoney - wager + coinsCollected;
        }
    } else {
        // Standard Notification Mode (Sender Viewing Later)
        newBalance = isWin ? (currentMoney + rewardAmount) : currentMoney;
    }

    const handleDismissClick = () => {
        setIsExiting(true);
    };

    const handleAnimationEnd = (e) => {
        if (isExiting && e.target.classList.contains('notification-overlay')) {
            onDismiss();
            setIsExiting(false);
        }
    };

    return (
        <div 
            className={`notification-overlay ${isExiting ? 'exiting' : ''}`} 
            onAnimationEnd={handleAnimationEnd}
            style={{ zIndex: 9999 }} // Ensure it sits on top of game container
        >
            <div className={`notification-card ${isWin ? 'win' : 'loss'} ${isExiting ? 'exiting' : ''}`}>
                <div className="notification-icon-wrapper">
                    {isWin ? <Trophy size={40} /> : <XCircle size={40} />}
                </div>

                <h2 className="notification-title">
                    {isWin ? 'Challenge Won!' : 'Challenge Lost'}
                </h2>

                <p className="notification-details">
                    {/* Contextual Text Logic */}
                    {deductWager ? (
                         isWin 
                            ? `You beat ${opponentName}'s target!` 
                            : `You failed to beat ${opponentName}.`
                    ) : (
                        isWin 
                        ? `${opponentName} failed to beat your score.`
                        : `${opponentName} beat your score of ${score || '---'}!`
                    )}
                </p>

                <div className="notification-stats">
                    <div className="stat-row">
                        <span className="stat-label">
                            {isWin ? 'Money Won:' : 'Money Lost:'}
                        </span>
                        <div className="coin-display">
                            <span className={`stat-value ${isWin ? 'green' : 'red'}`}>
                                {isWin ? '+' : '-'}{moneyChange}
                            </span>
                            <Coins size={14} className={isWin ? 'c-green' : 'c-red'} />
                        </div>
                    </div>

                    <div className="stat-row highlight">
                        <span className="stat-label">New Balance:</span>
                        <div className="coin-display">
                            <span className="stat-value gold">{newBalance}</span>
                            <Coins size={16} className="c-yellow" />
                        </div>
                    </div>
                </div>

                <button className="notification-btn" onClick={handleDismissClick}>
                    {isWin ? 'Collect Reward' : 'Dismiss'}
                </button>
            </div>
        </div>
    );
}

export default ChallengeNotification;